var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    transform: "matrix(1 0 0 -1 0 18)",
    fill: "#6F6F6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7498 7.94288L9.53228 11.1229C9.46256 11.1932 9.37961 11.249 9.28821 11.287C9.19682 11.3251 9.09879 11.3447 8.99978 11.3447C8.90077 11.3447 8.80274 11.3251 8.71135 11.287C8.61995 11.249 8.537 11.1932 8.46728 11.1229L5.28728 7.94288C5.21698 7.87316 5.16119 7.7902 5.12311 7.69881C5.08503 7.60742 5.06543 7.50939 5.06543 7.41038C5.06543 7.31137 5.08503 7.21334 5.12311 7.12194C5.16119 7.03055 5.21698 6.9476 5.28728 6.87788C5.4278 6.73819 5.61789 6.65978 5.81603 6.65978C6.01417 6.65978 6.20426 6.73819 6.34478 6.87788L8.99978 9.53288L11.6548 6.87788C11.7945 6.73932 11.983 6.66121 12.1798 6.66038C12.2785 6.65981 12.3763 6.67873 12.4677 6.71605C12.5591 6.75337 12.6422 6.80837 12.7123 6.87788C12.7851 6.94509 12.8439 7.02607 12.8852 7.11612C12.9265 7.20618 12.9496 7.30353 12.9531 7.40256C12.9566 7.50159 12.9404 7.60032 12.9055 7.69306C12.8706 7.7858 12.8177 7.87071 12.7498 7.94288Z",
    fill: "#EDF0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.20a5e2048b8b9370690747d55c0600ea.svg";
export { ForwardRef as ReactComponent };